import { Container, Grid } from "@mui/material";
import ClientAccount from "../components/multi-account/ClientAccount";
import { MultiAccountListStyles } from "../components/multi-account/index.styles";
import NoFooterLayout from "../components/core/NoFooterLayout";
import { useAppDispatch } from "src/store/store";
import api from "src/store/features/api";
import { AccountUsersRes, GetMultiAccountUsersApiResponse } from "src/store/features/api/generated";
import { useState } from "react";
import Loading from "src/components/loading/Loading";
import { setMultiUserData } from "src/store/features/multiUser.slice";
import { resetWithdrawalState } from "src/store/features/withdrawal.slice";
import { useHistory } from "react-router-dom";
import useHydrateUser from "src/utils/hooks/hydrateUser";

export default function AccountSelection() {
  const [setSelectedUser] = api.useSetSelectedUserMutation();
  const { data: multiAccountUsers = [] } = api.useGetMultiAccountUsersQuery();
  const [getUserData, { data: userData }] = api.useLazyGetUserDatav2Query();
  const [getUserMultiAccountData] = api.useLazyGetMultiAccountUsersQuery();
  const classes = MultiAccountListStyles();
  const reduxDispatch = useAppDispatch();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const hasSelectedAccount = multiAccountUsers.some((account) => account.selected);

  useHydrateUser({ userData, checkFirstTimeLogin: false }); // Hydrate user on account change

  const handleChangeAccount = async (account: AccountUsersRes) => {
    setLoading(true);
    await setSelectedUser({
      customerIdDto: {
        customerId: account.customerId,
      },
    });

    // Withdrawal + Travel-Rule state is PROFILE-scoped but persists
    // login-wide — same clear as MultiAccountList / MultiAccountListV2, so
    // this switch path can't leak the other profile's banner or prefilled
    // withdrawal form into the new profile. `useTravelRuleHydrate` restores
    // the banner from the server on switch-back. Only on a REAL switch:
    // clicking the already-active profile leaves `customerId` unchanged, so
    // the hydrate hook (keyed on customerId) would never re-reconcile and
    // the cleared banner couldn't come back until a full remount.
    const isActiveProfile = account.selected || (!hasSelectedAccount && account.default);
    if (!isActiveProfile) {
      reduxDispatch(resetWithdrawalState());
    }

    await getUserData();

    await getUserMultiAccountData()
      .unwrap()
      .then((userData: GetMultiAccountUsersApiResponse) => {
        reduxDispatch(setMultiUserData(userData));
      });

    setLoading(false);

    history.replace("/portfolio");
  };

  return (
    <NoFooterLayout>
      {loading && <Loading />}
      <Container>
        <Grid item className={classes.clientListContainer}>
          {multiAccountUsers.map((account, index) => (
            <Grid
              key={"multi-" + index}
              className={classes.clientListItem}
              onClick={() => handleChangeAccount(account)}>
              <ClientAccount
                account={account}
                showTick={account.selected || (!hasSelectedAccount && account.default)}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </NoFooterLayout>
  );
}
